<template>
  <v-card elevation="0" class="ma-0 pa-0 h-100 background_color grid-set">
    <div class="app-relative">
      <h4 class="white--text text-capitalize font-weight-light" style="position: absolute; left: 4%; top: 20px">
        {{ mainTitle}}
      </h4>
      <img class=" h-100" :src="imageSrc" style="width:102%" />
    </div>

    <v-card-text class="pa-0 my-0 ml-0" style="height:97%">
      <v-card
        outlined
        class="rounded-lg px-3 ma-0 h-100 d-flex algin-center"
        style="margin-left: -12px !important"
      >
        <v-row no-gutters>
          <v-col cols="3" v-if="icon" class="d-flex align-center">
            <v-icon :color="iconColor" large> {{ icon }} </v-icon>
          </v-col>
          <v-col cols="9" class="d-flex flex-column justify-center">
            <h1>{{ textValue ? textValue : "-" }}</h1>
            <h4 class="text-caption text-capitalize my-1">
              {{ text }}
            </h4>
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    mainTitle: {
      required: true,
    },
    imageSrc: {
      required: true,
    },
    iconColor: {
      required: false,
    },
    icon: {
      required: false,
    },
    text: {
      required: true,
    },
    textValue: {
      required: true,
    },
  },
};
</script>
<style scoped>
.grid-set {
  display: grid;
  grid-template-columns: 1fr 300px;
  height: 100%;
}
</style>